import React from 'react';
import {Spinner, SpinnerTypes} from '@wix/wix-ui-tpa/cssVars';
import {useLocaleKeys} from '../../../locale-keys/LocaleKeys';
import {SkipCheckoutFlowStatus} from '../../../types/checkoutApp.types';
import {classes} from './SkipCheckoutLayout.st.css';

export enum SkipCheckoutLayoutDataHooks {
  root = 'SkipCheckoutLayout.root',
  content = 'SkipCheckoutLayout.content',
  spinner = 'SkipCheckoutLayout.spinner',
  message = 'SkipCheckoutLayout.message',
}

export interface SkipCheckoutLayoutProps {
  status: SkipCheckoutFlowStatus.CheckingEligibility | SkipCheckoutFlowStatus.PlacingOrder;
}

export const SkipCheckoutLayout = ({status}: SkipCheckoutLayoutProps) => {
  const localeKeys = useLocaleKeys();
  const message =
    status === SkipCheckoutFlowStatus.PlacingOrder
      ? localeKeys.checkout.fastComplete.completingOrder.loader.title()
      : localeKeys.checkout.fastComplete.evaluating.loader.title();

  return (
    <div data-hook={SkipCheckoutLayoutDataHooks.root} className={classes.root}>
      <div data-hook={SkipCheckoutLayoutDataHooks.content} className={classes.content}>
        <Spinner data-hook={SkipCheckoutLayoutDataHooks.spinner} type={SpinnerTypes.slim} diameter={92} />
        <span data-hook={SkipCheckoutLayoutDataHooks.message} className={classes.message}>
          {message}
        </span>
      </div>
    </div>
  );
};
